import { ROUTES } from "./routes";

export const isArticleValid = (article: { title?: string; date?: string }) => {
  return article?.title && article?.date;
};

export const getArticleAssetData = (labels) => ({
  0: { link: ROUTES.ASSETS_IMAGES, title: labels?.assetsImages },
  1: { link: ROUTES.ASSETS_VIDEOS, title: labels?.assetsVideos },
  2: { link: ROUTES.ASSETS_FACT, title: labels?.assetsFactSheets },
});

export enum ARTICLE_TAG {
  INTERNATIONAL = "INTERNATIONAL",
  US_CANADA = "US & CANADA",
}
